import {
	Button,
	DatePicker,
	Form,
	Input,
	Modal,
	Select
} from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getAllGender } from "../../../redux/rtk/features/masters/genderSlice";
import { getAllSalutation } from "../../../redux/rtk/features/masters/salutationSlice";
import {
	loadSingleStaff,
	updateUser
} from "../../../redux/rtk/features/user/userSlice";
import getPermissions from "../../../utils/getPermissions";
import BtnEditSvg from "../Button/btnEditSvg";


const ProfileEditPopup = ({ data }) => {
	const { Option } = Select;

	const [isModalOpen, setIsModalOpen] = useState(false);
	const [loader, setLoader] = useState(false);
	const user = useSelector((state) => state.users?.user);
	const { id } = useParams();
	const dispatch = useDispatch();
	const [form] = Form.useForm();
	const gender = useSelector((state) => state.gender?.list);
	const salutation = useSelector((state) => state.salutation?.list);
	const permissions = getPermissions();
	const hasPermission = (item) => {
		return permissions?.includes(item ? item : "");
	};
	useEffect(() => {
		dispatch(getAllGender())

		dispatch(getAllSalutation())
	}, []);

	useEffect(() => {

		if (user) {
			form.setFieldsValue({
				salutationId: user.salutationId || "",
				firstName: user.firstName || "",
				lastName: user.lastName || "",
				userName: user.userName || "",
				bloodGroup: user.bloodGroup || "",
				birthAnniversary: user.birthAnniversary ? dayjs(user.birthAnniversary) : null,
				birthdate: user.birthdate ? dayjs(user.birthdate) : null,
				maritalStatus: user.maritalStatus === 1
					? "Married"
					: user.maritalStatus === 0
						? "Single"
						: "N/A",

				marriageAnniversary: user.marriageAnniversary ? dayjs(user.marriageAnniversary) : null,
				gender: user.gender || "",
			});
		}
	}, [user, form]);

	const showModal = () => setIsModalOpen(true);
	const handleCancel = () => setIsModalOpen(false);
	const onFinish = async (values) => {
		console.log('values.maritalStatus:', values.maritalStatus);

		const maritalStatus =
			values.maritalStatus === "Married"
				? 1
				: values.maritalStatus === "Single"
					? 0
					: null;

		try {
			setLoader(true);

			// Format the dates to only have the date part, not the time
			const updatedValues = {
				...values,
				birthdate: values.birthdate ? values.birthdate.format("YYYY-MM-DD") : null,
				birthAnniversary: values.birthAnniversary ? values.birthAnniversary.format("YYYY-MM-DD") : null,
				marriageAnniversary: values.marriageAnniversary ? values.marriageAnniversary.format("YYYY-MM-DD") : null,
				maritalStatus
			};

			const resp = await dispatch(
				updateUser({
					id: id,
					values: updatedValues,
				})
			);

			if (resp.payload.message === "success") {
				dispatch(loadSingleStaff(id));
				toast.success("User information updated successfully");
				setIsModalOpen(false);
			} else {
				toast.error("Error updating user information");
			}
		} catch (error) {
			console.error(error.message);
			toast.error("Something went wrong");
		} finally {
			setLoader(false);
		}
	};

	return (
		<>
			<button onClick={showModal}>
				<BtnEditSvg size={30} />
			</button>
			<Modal
				width="50%"
				title="Update User Information"
				open={isModalOpen}
				onCancel={handleCancel}
				footer={null}>
				<Form
					form={form}
					layout="vertical"
					onFinish={onFinish}
					initialValues={form.getFieldsValue()}>
					<Form.Item
						label="Title"
						name="salutationId"
						rules={[
							{ required: true, message: "Please select your Title!" },
						]}
					>
						<Select placeholder="Select Title" showSearch allowClear mode="combobox">
							{salutation &&
								salutation.map((salutation) => (
									<Option key={salutation.id} value={salutation.id}>
										{salutation.salutations}
									</Option>
								))}
						</Select>
					</Form.Item>
					<Form.Item
						label="First Name"
						name="firstName"
						rules={[{ required: true, message: "Please input First Name!" }]}>
						<Input placeholder="First Name" />
					</Form.Item>
					<Form.Item
						label="Last Name"
						name="lastName"
						rules={[{ required: true, message: "Please input Last Name!" }]}>
						<Input placeholder="Last Name" />
					</Form.Item>
					{/* <Form.Item label="User Name" name="userName">
						<Input placeholder="User Name" />
					</Form.Item> */}
					<Form.Item label="User Name" name="userName">
						{hasPermission("update-role") ? (
							<Input placeholder="User Name" />
						) : (
							<Input placeholder="User Name" disabled />
						)}
					</Form.Item>

					<Form.Item
						style={{ marginBottom: "10px" }}
						label="Gender"
						name="gender"
					// rules={[
					// 	{ required: true, message: "Please select your gender!" },
					// ]}
					>
						<Select placeholder="Select Gender" showSearch allowClear mode="combobox">
							{gender &&
								gender.map((gender) => (
									<Option key={gender.id} value={gender.id}>
										{gender.gender}
									</Option>
								))}
						</Select>
					</Form.Item>
					<Form.Item label="D.O.B" name="birthAnniversary">
						<DatePicker format="YYYY-MM-DD" />
					</Form.Item>
					<Form.Item label="Blood Group" name="bloodGroup">
						<Select placeholder="Select Blood Group">
							{["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"].map((group) => (
								<Select.Option key={group} value={group}>
									{group}
								</Select.Option>
							))}
						</Select>
					</Form.Item>
					{/* <Form.Item label="Birth Date" name="birthdate">
						<DatePicker format="YYYY-MM-DD" />
					</Form.Item> */}

					<Form.Item label="Marital Status" name="maritalStatus">
						<Select placeholder="Select Status">
							<Select.Option value="Single">Single</Select.Option>
							<Select.Option value="Married">Married</Select.Option>
						</Select>
					</Form.Item>
					{/* <Form.Item label="Marriage Anniversary" name="marriageAnniversary">
						<DatePicker format="YYYY-MM-DD" />
					</Form.Item> */}


					<Form.Item>
						<Button type="primary" htmlType="submit" loading={loader} block>
							Update
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</>
	);
};

export default ProfileEditPopup;

